import { defineStore } from 'pinia';
import { ofetch } from 'ofetch';
import type { AuthUser, LoginResponse } from '@/types/api';

const TOKEN_KEY = 'sov-admin-token';
const USER_KEY = 'sov-admin-user';
const API_BASE = (import.meta.env.VITE_API_BASE || 'http://localhost:4500').replace(/\/$/, '');

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: (typeof localStorage !== 'undefined' && localStorage.getItem(TOKEN_KEY)) || ('' as string),
    user: ((): AuthUser | null => {
      if (typeof localStorage === 'undefined') return null;
      const raw = localStorage.getItem(USER_KEY);
      try {
        return raw ? (JSON.parse(raw) as AuthUser) : null;
      } catch {
        return null;
      }
    })(),
  }),
  getters: {
    isAuthenticated: (s) => Boolean(s.token && s.user),
  },
  actions: {
    async login(email: string, password: string): Promise<void> {
      const res = await ofetch<LoginResponse>(`${API_BASE}/v1/auth/login`, {
        method: 'POST',
        body: { email, password },
      });
      this.token = res.token;
      this.user = res.user;
      localStorage.setItem(TOKEN_KEY, res.token);
      localStorage.setItem(USER_KEY, JSON.stringify(res.user));
    },
    logout() {
      this.token = '';
      this.user = null;
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
    },
  },
});
